import TestStreamToggle from './test-stream-toggle';
import EditStateWrapper from '@ui/edit-state-wrapper/edit-state-wrapper';

const TestStreamToggleWithEditState = () => {
  return (
    <EditStateWrapper hideEditLabel Label="TEST MODE">
      <div data-show-edit-label="true">
        <TestStreamToggle primaryThemeColor />
      </div>
    </EditStateWrapper>
  );
};

export default TestStreamToggleWithEditState;
